const buttons = document.querySelectorAll('.section-assine-ja__container__row__time-line__option__item__button');
const optionList = document.querySelectorAll('[data-assine-ja-option-list]');

buttons.forEach((button) => {
	button.addEventListener('click', () => {
		buttons.forEach((btn) => btn.classList.remove('channel-category-selected'));
		button.classList.add('channel-category-selected');
		optionList.forEach((option) => {
			const buttonInnerText = button.innerText.toLowerCase();
			if (buttonInnerText !== 'todos') {
				const optionData = option.attributes['data-assine-ja-option-list'].nodeValue;
				option.style.display = optionData === buttonInnerText ? 'flex' : 'none';
			} else {
				option.style.display = 'flex';
			}
		});
	});
});


const card = [];
let subtotal = 0;

const ids = ['add-globoplay', 'add-paramount', 'add-premiere', 'add-combate', 'add-combo'];

function addEventListenerById(id) {
    const element = document.getElementById(id);
    if (element) {
        element.addEventListener('click', () => handleAddToCart(element));
    }
}

ids.forEach(addEventListenerById);

function handleAddToCart(e) {
    const { dataset: { planPrice, plan } } = e;
    const price = parseFloat(planPrice);
    const removedItem = handleRemoveCartItem(plan);

    if (removedItem) {
        return;
    }

    if (plan === 'Premiere + Combate') {
        handleRemoveCartItem('Premiere');
        handleRemoveCartItem('Combate');
    }

    if (plan === 'Premiere' || plan === 'Combate') {
        handleRemoveCartItem('Premiere + Combate');
    }

    const spanElement = e.querySelector('span');
    const imgElementAdd = e.querySelector('.icon-add-cards-streaming');
    const imgElementCheck = e.querySelector('.icon-check-cards-streaming');

    toggleClass(e, 'section-assine-ja__container__cards__content__cta-add__adicionado', true);
    toggleClass(imgElementAdd, 'icon-cards-streaming-show', false);
    toggleClass(imgElementAdd, 'icon-cards-streaming-hidden', true);
    toggleClass(imgElementCheck, 'icon-cards-streaming-show', true);
		toggleClass(imgElementCheck, 'icon-cards-streaming-hidden', false);
    spanElement.innerText = 'Adicionado';

    const checkOutItem = { price, plan };
    card.push(checkOutItem);
    subtotal += price;
    updateSubtotalValue();
    addTag(plan, price);
}

function handleRemoveCartItem(plan) {
    const indexToRemove = card.findIndex(item => item.plan === plan);
    if (indexToRemove !== -1) {
        const { price } = card[indexToRemove];
        subtotal -= price;
        card.splice(indexToRemove, 1);
        updateSubtotalValue();
        handleBtnTagRemove(plan);
        updateStyleBtnCard(plan);
        return true;
    }
    return false;
}

function toggleClass(element, className, add) {
    if (add) {
        element.classList.add(className);
    } else {
        element.classList.remove(className);
    }
}

function addTag(plan, price) {
    const btnTag = document.createElement('button');
    btnTag.classList.add('section-assine-ja__container__offer-card__streamings__container__add');
    btnTag.dataset.planTag = plan;
    btnTag.dataset.priceTag = price;
    btnTag.onclick = () => handleRemoveCartItem(plan);

    const imgTag = document.createElement('img');
    imgTag.src = document.getElementById('icon-tag-base').src;
    imgTag.alt = 'Ícone remover';
    btnTag.appendChild(imgTag);
    btnTag.innerHTML += plan;

    document.getElementById('listaStreamingsContainer').appendChild(btnTag);
    handleHrefSVoip(plan, true);
}

function updateSubtotalValue() {
    const subtotalValue = document.getElementById('subtotalValue');
    const subtotalToBrCurrency = subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    const subtotalFormatted = `${subtotalToBrCurrency.replace('-', '')} <b> /mês</b>`;
    subtotalValue.innerHTML = subtotalFormatted;
}

function handleBtnTagRemove(plan) {
    handleHrefSVoip(plan, false);
    document.querySelectorAll('button[data-plan-tag]').forEach(btn => {
        if (btn.dataset.planTag === plan) {
            btn.parentNode.removeChild(btn);
        }
    });
}

function updateStyleBtnCard(planTag) {
    document.querySelectorAll('button[data-plan]').forEach(btn => {
        if (btn.dataset.plan === planTag) {
            const imgElementAdd = btn.querySelector('.icon-add-cards-streaming');
            const imgElementCheck = btn.querySelector('.icon-check-cards-streaming');
						
						toggleClass(imgElementAdd, 'icon-cards-streaming-show', true);
						toggleClass(imgElementAdd, 'icon-cards-streaming-hidden', false);
						toggleClass(imgElementCheck, 'icon-cards-streaming-show', false);
						toggleClass(imgElementCheck, 'icon-cards-streaming-hidden', true);

            const spanElement = btn.querySelector('span');
            spanElement.innerText = 'Adicionar';
            toggleClass(btn, 'section-assine-ja__container__cards__content__cta-add__adicionado', false);
        }
    });
}

const cardsContainerElement = document.getElementById('assineJaCarrossel');

function setCardsLeftPaddingValue() {
    const element = document.getElementById('maxWidthCards');
    if (!element) return;

    const windowMarginValue = parseFloat(window.getComputedStyle(element).marginLeft);
    const windowPaddingValue = parseFloat(window.getComputedStyle(element).paddingLeft);
    const cardsPaddingValue = `${windowMarginValue + windowPaddingValue}px`;
    cardsContainerElement.style.paddingLeft = cardsPaddingValue;
}
setCardsLeftPaddingValue();

window.addEventListener('resize', setCardsLeftPaddingValue);

const grabScrollCardDesktop = () => {
    let isDown = false;
    let startX;
    let scrollLeft;

    cardsContainerElement.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX;
        scrollLeft = cardsContainerElement.scrollLeft;
        let timeoutId;

        timeoutId = setTimeout(() => {
            if (isDown) {
                cardsContainerElement.classList.add('scrollMouseActive');
            }
        }, 100);
    });

    cardsContainerElement.addEventListener('mouseleave', () => {
        isDown = false;
        cardsContainerElement.classList.remove('scrollMouseActive');
    });

    cardsContainerElement.addEventListener('mouseup', () => {
        isDown = false;
        cardsContainerElement.classList.remove('scrollMouseActive');
    });

    cardsContainerElement.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();

        requestAnimationFrame(() => {
            const x = e.pageX - cardsContainerElement.offsetLeft;
            const walk = x - startX;
            cardsContainerElement.scrollLeft = scrollLeft - walk;
        });
    });
};
grabScrollCardDesktop();

function handleHrefSVoip(plan, add) {
    const ctaConsulta = document.getElementById('btn_consultar_disponibilidade');
    let ctaHref = ctaConsulta.getAttribute('href');
    let planSVoip;

    switch (plan) {
        case 'Globoplay':
            planSVoip = 'SVOD_GLOBOPLAY_BASICO';
            break;
        case 'Paramount+':
            planSVoip = 'PRMNT_PLUS';
            break;
        case 'Combate':
            planSVoip = 'CMBT_PLAY';
            break;
        case 'Premiere':
            planSVoip = 'PRMR_PLAY';
            break;
        case 'Premiere + Combate':
            planSVoip = 'CMBT_PLAY,PRMR_PLAY';
            break;
        default:
            console.log('Plan not found:', plan);
            return;
    }

    if (add) {
        ctaHref = ctaHref ? (ctaHref.endsWith('=') ? `${ctaHref}${planSVoip}` : `${ctaHref},${planSVoip}`) : '';
    } else {
        if (ctaHref.includes(planSVoip)) {
            ctaHref = ctaHref.replace(planSVoip, '').replace(',,', ',').replace(/,$/, '');
        } else {
            console.log('Value not found in href:', planSVoip);
        }
    }

    ctaConsulta.setAttribute('href', ctaHref);
}

